var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B0F0FF",
    d: "M7.38 8.914L3.236 4.768c-4.313 5.057-4.313 12.55 0 17.607l4.146-4.147c-2.071-2.75-2.071-6.565 0-9.314M18.228 7.38l4.147-4.145c-5.058-4.313-12.551-4.313-17.608 0L8.914 7.38c2.75-2.071 6.565-2.071 9.314 0M8.914 19.761l-4.146 4.147c5.056 4.312 12.55 4.312 17.607 0l-4.147-4.147c-2.75 2.071-6.565 2.071-9.314 0M19.761 18.228l4.147 4.147c4.312-5.057 4.312-12.55 0-17.608L19.76 8.914c2.071 2.75 2.071 6.565 0 9.314",
    transform: "translate(.916 .963)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003DB3",
    d: "M19.055 19.055c-.261.26-.54.49-.826.706l4.146 4.147c.273-.233.542-.475.8-.733.258-.259.5-.527.733-.8l-4.147-4.147c-.216.287-.445.566-.706.827M8.087 8.087c.261-.26.54-.49.827-.706L4.767 3.235c-.273.233-.541.474-.8.732-.258.258-.5.528-.732.8L7.38 8.914c.216-.287.445-.566.706-.827M22.375 3.235L18.229 7.38c.286.216.565.446.826.706.26.261.49.54.706.827l4.147-4.147c-.234-.272-.475-.54-.733-.799-.258-.258-.527-.5-.8-.733M8.087 19.055c-.26-.261-.49-.54-.706-.826l-4.146 4.146c.233.273.474.542.732.8s.527.5.8.733l4.147-4.147c-.287-.216-.566-.445-.827-.706",
    transform: "translate(.916 .963)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPool);
export default __webpack_public_path__ + "static/media/pool.0616bcbab5a96914c53aa5bbd931d9f1.svg";
export { ForwardRef as ReactComponent };